<p class="flex" [class.column]="vertical" [class]="size" [matTooltip]="hint ? (hint.text | translate) : undefined">
  @if (name) {
    <app-icon [name]="name" [size]="size"/>
  }
  @if (hint) {
    @if (hint.error) {
      <app-icon name="ic_problem" class="hint error"/>
    }
  }
  <span [class.error]="hint?.error"><ng-content></ng-content></span>
</p>
